
import { Label } from "@/components/ui/label";
import { useIsMobile } from "@/hooks/use-mobile";

type ScoreType = "birdie" | "eagle" | "double_eagle";

interface ScoreTypeSelectorProps {
  value: ScoreType;
  onChange: (value: ScoreType) => void;
}

const scoreTypeOptions: { value: ScoreType; label: string }[] = [
  { value: "birdie", label: "Birdie" },
  { value: "eagle", label: "Eagle" },
  { value: "double_eagle", label: "Albatross" },
];

export const ScoreTypeSelector = ({ value, onChange }: ScoreTypeSelectorProps) => {
  const isMobile = useIsMobile();

  return (
    <div className="space-y-1">
      <Label className={isMobile ? "text-xs" : ""}>Score Type</Label>
      <div className="flex gap-2">
        {scoreTypeOptions.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={`flex-1 rounded-md border px-3 ${isMobile ? "py-1.5 text-xs" : "py-2 text-sm"} font-medium transition-colors ${
              value === option.value
                ? option.value === "birdie"
                  ? "bg-emerald-600 text-white border-emerald-600"
                  : option.value === "eagle"
                    ? "bg-amber-500 text-white border-amber-500"
                    : "bg-yellow-500 text-white border-yellow-500"
                : "bg-background text-foreground border-input hover:bg-accent"
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};
